import { render, staticRenderFns } from "./IconNoInternet.vue?vue&type=template&id=3023fbfe&"
import script from "./IconNoInternet.vue?vue&type=script&lang=js&"
export * from "./IconNoInternet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports